import React from "react"

import * as style from "./Tabs.module.scss"

const Label = ({ label, onSelection, selected }) => (
  <a
    className={style.label}
    data-selected={selected}
    onClick={() => onSelection(label)}
  >
    {label}
  </a>
)

export default Label
